'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = OnlinepbxModalMessage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SuccessIcon = function () {
  function SuccessIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M40 14L18 36 8 26',
        stroke: '#00BB20',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return SuccessIcon;
}();

SuccessIcon.defaultProps = {
  width: '48',
  height: '48',
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var ErrorIcon = function () {
  function ErrorIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        clipRule: 'evenodd',
        d: 'M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z',
        stroke: '#E51C23',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        d: 'M24 16v8',
        stroke: '#E51C23',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('circle', {
        cx: '24',
        cy: '32',
        r: '1.6',
        fill: '#E51C23'
      })
    );
  }

  return ErrorIcon;
}();

ErrorIcon.defaultProps = {
  width: '48',
  height: '48',
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var InfoIcon = function () {
  function InfoIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        clipRule: 'evenodd',
        d: 'M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z',
        stroke: '#0D71D7',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        d: 'M24 32v-8',
        stroke: '#0D71D7',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('ellipse', {
        cx: '24',
        cy: '16',
        rx: '2',
        ry: '2',
        fill: '#0D71D7'
      })
    );
  }

  return InfoIcon;
}();

InfoIcon.defaultProps = {
  width: '48',
  height: '48',
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};
function OnlinepbxModalMessage(_ref) {
  var onClickWrapper = _ref.onClickWrapper,
      status = _ref.status,
      text = _ref.text,
      buttons = _ref.buttons,
      header = _ref.header,
      onClickButtonFill = _ref.onClickButtonFill,
      textButtonFill = _ref.textButtonFill,
      linkButtonLink = _ref.linkButtonLink,
      onClickButtonLink = _ref.onClickButtonLink,
      textButtonLink = _ref.textButtonLink,
      isModal = _ref.isModal,
      otherProps = _objectWithoutProperties(_ref, ['onClickWrapper', 'status', 'text', 'buttons', 'header', 'onClickButtonFill', 'textButtonFill', 'linkButtonLink', 'onClickButtonLink', 'textButtonLink', 'isModal']);

  return _react2['default'].createElement(
    'div',
    _extends({
      onClick: function () {
        function onClick(evt) {
          return typeof onClickWrapper === 'function' && onClickWrapper(evt);
        }

        return onClick;
      }(),
      className: (0, _classnames2['default'])('onlinepbx__lib__modal__message', {
        'onlinepbx__lib__modal__message__isModal': isModal
      })
    }, otherProps),
    _react2['default'].createElement(
      'div',
      { className: 'onlinepbx__lib__modal__message__content' },
      status !== 'empty' && _react2['default'].createElement(
        'div',
        { className: 'onlinepbx__lib__modal__message__icon' },
        status === 'success' && _react2['default'].createElement(SuccessIcon, { className: 'onlinepbx__lib__modal__message__icon__success' }) || status === 'info' && _react2['default'].createElement(InfoIcon, { className: 'onlinepbx__lib__modal__message__icon__info' }) || _react2['default'].createElement(ErrorIcon, { className: 'onlinepbx__lib__modal__message__icon__error' })
      ),
      _react2['default'].createElement(
        'div',
        { className: (0, _classnames2['default'])('onlinepbx__lib__modal__message__header', {
            'onlinepbx__lib__modal__message__header__noicon': status === 'empty'
          }) },
        header
      ),
      _react2['default'].createElement(
        'div',
        { className: 'onlinepbx__lib__modal__message__text' },
        text
      ),
      buttons && _react2['default'].createElement(
        'div',
        { className: 'onlinepbx__lib__modal__message__buttons' },
        status !== 'success' && textButtonFill && _react2['default'].createElement(
          'div',
          { className: (0, _classnames2['default'])('onlinepbx__lib__modal__message__button', {
              'onlinepbx__lib__modal__message__button__link': !textButtonLink
            }) },
          _react2['default'].createElement(_index.OnlinepbxButtonFill, {
            text: textButtonFill,
            onClick: function () {
              function onClick(evt) {
                return typeof onClickButtonFill === 'function' && onClickButtonFill(evt);
              }

              return onClick;
            }()
          })
        ),
        textButtonLink && _react2['default'].createElement(
          'div',
          { className: (0, _classnames2['default'])({
              'onlinepbx__lib__modal__message__button__close': status === 'success'
            }) },
          _react2['default'].createElement(_index.OnlinepbxButtonLink, {
            link: linkButtonLink,
            text: textButtonLink,
            onClick: function () {
              function onClick(evt) {
                return typeof onClickButtonLink === 'function' && onClickButtonLink(evt);
              }

              return onClick;
            }() })
        )
      )
    )
  );
}